import Tabs from "@/components/Tabs";
import { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";
import { Path } from "@/router";
import { useParams } from "react-router-dom";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const { pgaId } = useParams();
  const canViewOrders = useHasCapabilityBool({
    domain: DOMAIN.COMMERCE,
    permission: PERMISSION.viewOrders
  });
  const canViewPersonBilling = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonBilling
  });

  if (!pgaId) return null;

  const tabItems = [
    canViewOrders && {
      label: "Orders",
      link: `/people/${pgaId}/billing/orders` as Path
    },
    canViewPersonBilling && {
      label: "Payout Profiles",
      link: `/people/${pgaId}/billing/payout-profiles` as Path
    }
  ].filter(Boolean) as { label: string; link: Path }[];

  return (
    <>
      <Tabs tabItems={tabItems} />
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
